import EventEmmiter from '../helpers/EventEmmiter';
import { generateUUID } from '../helpers/common';

const MODE_IDLE = 'MODE_IDLE';
const MODE_READ_ONLY = 'MODE_READ_ONLY';
const MODE_MANAGING_LAYERS = 'MODE_MANAGING_LAYERS';

export class FloorPlanPreviewModel {

    iframe = null;
    iframeWindow = null;
    plan = {};
    _mode = MODE_READ_ONLY;

    constructor(plan = {}, editable) {
        for (let key in plan) {
            if (plan.hasOwnProperty(key)) {
                this[key] = plan[key];
            }
        }
        this.iframeUrl = editable ? `build/floor-planner/template.html?token=${generateUUID()}` :  `floor-planner/index.html?token=${generateUUID()}`;
    }

    get mode() {
        return this._mode;
    }

    set mode(mode) {
        this._mode = mode;
    }
}

export default class FloorplanPreview extends EventEmmiter {

    _container = null;
    _listener = null;
    _preview = null;
    _transferOrigin = '*';
    _iframeId = 'e3-planner-preview';

    constructor(container, editable = false, params={type: '2d', metrical: true, iframeID: 'e3-planner-preview'}) {
        super();
        let plan = {};
        this._container = container;
        this._preview = new FloorPlanPreviewModel({plan}, editable);
        this._iframeId = params.iframeID ? params.iframeID : this._iframeId;

        this._init(params);
    }

    _init(params){
        this._bindEvents();
        this._createIframe(params);
    }

    _serialize(obj){
        var str = "";
        for (var key in obj) {
            if (str != "") {
                str += "&";
            }
            str += key + "=" + encodeURIComponent(obj[key]);
        }

        return str;
    }

    _createIframe(params) {
        let urlParams = this._serialize(params);
        this._preview.iframe = document.createElement('iframe');
        // this._preview.iframe.width = '290';
        this._preview.iframe.id = this._iframeId;
        this._preview.iframe.onload = () => {
            this._preview.iframeWindow = this._preview.iframe.contentWindow;
        };

        this._preview.iframe.src = this._preview.iframeUrl + '?' + urlParams;

        this.addLoading();

        this._container.appendChild(this._preview.iframe);
    }

    addLoading() {
        this._container.classList.add('loading');
    }

    removeLoading() {
        this._container.classList.remove('loading');
    }

    _bindEvents() {
        this._listener = this._messageListener.bind(this);

        window.addEventListener('message', this._listener);
    }

    _messageListener(message) {
        if (this._preview.iframe.contentWindow !== message.source) return;

        switch (message.data.event) {
            case 'e3.planner.ready':
                // this._loadPlan(this._preview.plan);
                this._fireEvent('ready');
                this.removeLoading();
                break;
            case 'e3.planner.save':
                // this._preview.iframeWindow.postMessage({event: 'e3.admin.saved', result: 'success'}, this._transferOrigin);
                this._fireEvent('save.plan', message.data.scene);
            case 'e3.planner.update':
                // this._preview.iframeWindow.postMessage({event: 'e3.admin.saved', result: 'success'}, this._transferOrigin);
                this._fireEvent('update.plan');
                break;
            case 'e3.planner.minimize':
                this.togglePreviewMode(message.data.scene);
                // this._fireEvent('save.plan', message.data.scene);
                break;
            case 'e3.planner.screenshots':
                this._fireEvent('screenshots', message.data.screenShots);
                break;
            case 'e3.planner.exit':
                break;
            case 'e3.planner.mousedown':
                this._fireEvent('e3.planner.mousedown');
            case 'e3.planner.loading.finish':
                this._fireEvent('e3.planner.loading.finish');
                break;
            case 'e3.planner.selectArea':
                this._fireEvent('e3.planner.selectArea', message.data.sceneID);
                break;
            case 'e3.planner.removeLayer':
                this._fireEvent('e3.planner.removeLayer', message.data.layerID);
                break;
            case 'e3.planner.remove.hole':
                this._fireEvent('e3.planner.remove.hole', message.data.holeID);
                break;
            case 'e3.planner.change.floors':
                this._fireEvent('e3.planner.change.floors', message.data.obj);
                break;
            case 'e3.planner.remove.area':
                this._fireEvent('e3.planner.remove.area', message.data.areaID);
                break;
            case 'e3.planner.set.layer.properties':
                this._fireEvent('e3.planner.set.layer.properties', message.data.data);
                break;
            case 'e3.planner.update.scene.properties':
                this._fireEvent('e3.planner.update.scene.properties', message.data.data);
                break;
            case 'e3.planner.change.fontSize.layer':
                this._fireEvent('e3.planner.change.fontSize.layer', message.data.data);
                break;
            case 'e3.planner.update.scene.color.properties':
                this._fireEvent('e3.planner.update.scene.color.properties', message.data.data);
                break;
            case 'e3.planner.set.floor.params':
                this._fireEvent('e3.planner.set.floor.params', message.data.data);
                break;
            case 'e3.planner.addLayer':
                this._fireEvent('e3.planner.addLayer', message.data.value, message.data.prevLayerId);
                break;
            case 'e3.planner.selectLayer':
                this._fireEvent('e3.planner.selectLayer', message.data.id);
                break;
            case 'e3.planner.helpModal':
                this._fireEvent('e3.planner.helpModal', {});
                break;
            case 'e3.planner.show.3d': {
                this.togglePreviewMode();
                this._fireEvent('show.3d');
            }
        }
    }

    _loadPlan(plan = {}, type = '', clean = false, defaultPlan) {
        this._preview.iframeWindow = !this._preview.iframeWindow ? document.getElementById(this._iframeId).contentWindow : this._preview.iframeWindow;
        this._preview.iframeWindow.postMessage({event: 'e3.admin.config', config:plan, defaultPlan, type, clean}, this._transferOrigin);

        this._fireEvent('disabled', !this._checkPlanVertices(plan));
    }

    _checkPlanVertices(plan) {
        if (!plan || !plan.layers) return false;

        return Object.keys(plan.layers).some((id) => {
            return Object.keys(plan.layers[id].vertices).length > 2;
        })
    }

    destroy() {
        super.destroy();
        window.removeEventListener('message', this._listener);
        this._container.appendChild(this._preview.iframe);
        for(let obj in this._preview){
            this._preview[obj] = null;
        }
        this._preview = null;
    }

    loadScreenshot(plan = {}, type='') {
        this._preview.iframeWindow = !this._preview.iframeWindow ? document.getElementById(this._iframeId).contentWindow : this._preview.iframeWindow;
        this._preview.iframeWindow.postMessage({event: 'e3.admin.screenshot', config: plan ? plan.preview : null, type}, this._transferOrigin);
    }

    updatePlan(plan = {}, type='', clean = false, defaultPlan) {
        this._loadPlan(plan, type, clean, defaultPlan);
    }

    sendAction(action, status) {
        if(!this._preview) return ;
        this._preview.iframeWindow = !this._preview.iframeWindow ? document.getElementById(this._iframeId).contentWindow : this._preview.iframeWindow;
        this._preview.iframeWindow.postMessage({event: 'e3.floorplan.action', action:action, status:status}, this._transferOrigin);
    }

    minimize(scene) {
        this._preview.iframe.classList.remove('full-screen');
        this._minimizeScreen();
        this._fireEvent('full.screen', {active: false, scene});
        this._preview.mode = MODE_READ_ONLY;
    }


    _minimizeScreen() {
        this._preview.iframeWindow = !this._preview.iframeWindow ? document.getElementById(this._iframeId).contentWindow : this._preview.iframeWindow;
        this._preview.iframeWindow.postMessage({event: 'e3.admin.minimize-screen'}, this._transferOrigin);
    }

    toggleLayerManagerMode(scene) {
        this._preview.mode = MODE_MANAGING_LAYERS;
        this._preview.iframe.classList.add('full-screen');
        this._preview.iframeWindow.postMessage({event: 'e3.admin.full-screen', mode: this._preview.mode},this._transferOrigin);
        this._preview.iframe.focus();
        this._fireEvent('full.screen', {active: true, scene});
    }

    isReadOnly() {
        return this._preview.mode === MODE_READ_ONLY;
    }

    togglePreviewMode(scene) {
        this._preview.mode = [MODE_IDLE, MODE_MANAGING_LAYERS].includes(this._preview.mode) ? MODE_READ_ONLY : MODE_IDLE;
        if (this._preview.mode === MODE_IDLE) {
            this._preview.iframe.classList.add('full-screen');
            this._preview.iframeWindow.postMessage({event: 'e3.admin.full-screen', mode: this._preview.mode},this._transferOrigin);
            this._preview.iframe.focus();
            this._fireEvent('full.screen', {active: true, scene});
        } else {
            this._minimizeScreen();
            this._preview.iframe.classList.remove('full-screen');
            this._fireEvent('full.screen', {active: false, scene});
        }
    }
}
